import Loading from './Loading';

export default Loading;



// WEBPACK FOOTER //
// ./src/views/components/Loading/index.js